import { Component, inject, input, output } from "@angular/core";
import { Router } from "@angular/router";
import { Cross, LucideAngularModule } from "lucide-angular";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "li[app-dropdown-item-uif]",
  imports: [LucideAngularModule],
  templateUrl: "./dropdown-item-uif.component.html",
})
export class DropdownItemUifComponent {
  //#region I/O
  icon = input(Cross);
  name = input(" ");
  route = input("");
  itemClicked = output<void>();
  router = inject(Router);
  //#endregion

  //#region UI Events
  onClicked() {
    // Emit the click event
    this.itemClicked.emit();

    if (this.route() !== "none") {
      this.router.navigate([this.route()]);
    }
  }

  //#endregion
}
